import FormLabelGroup, {
  FormLabelGroupProps,
} from '@appfolio/react-gears/lib/components/FormLabelGroup';
import classNames from 'classnames';
import React from 'react';
import MultiplierInput, {
  MultiplierInputProps,
} from '../inputs/MultiplierInput';

export type MultiplierFieldProps = FormLabelGroupProps & MultiplierInputProps;

export default function MultiplierField({
  label,
  required,
  hint,
  rowClassName,
  validate,
  initialValue,
  feedback,
  tableField,
  ...props
}: MultiplierFieldProps) {
  return (
    <FormLabelGroup
      stacked
      label={label}
      required={required}
      hint={hint}
      inputId={props.id}
      rowClassName={classNames(rowClassName, { 'no-gutters mb-0': tableField })}
      feedback={feedback}
    >
      <MultiplierInput {...props} />
    </FormLabelGroup>
  );
}
